import {createReducer, on} from '@ngrx/store';
import * as UserActions from '../_actions/user.actions';
import {LoggedUser} from '../_interfaces/logged-user';
import {authorFromUser} from 'app/_reducers/authorFromUser.fn';
import {DocumentationEntryAuthor} from 'app/_models/model/documentationEntryAuthor';

export const userFeatureKey = 'user';

export interface UserState {
	loggedUser: LoggedUser;
	loggedUserAuthor: DocumentationEntryAuthor;
	latestVersion: boolean;
	admin: boolean;
	logout: boolean;
	tokenRefreshing: boolean;
	logoutAfterEntrySave: boolean;
}

export const initialState: UserState = {
	loggedUser: null,
	loggedUserAuthor: null,
	latestVersion: true,
	admin: false,
	logout: false,
	tokenRefreshing: false,
	logoutAfterEntrySave: false
};

export const reducer = createReducer(
	initialState,
	on(UserActions.initUser, state => state),
	on(UserActions.login, (state, {user}) => ({
		...state,
		loggedUser: user,
		loggedUserAuthor: authorFromUser(user),
		logout: false
	})),
	on(UserActions.latestVersion, (state) => ({
		...state,
		latestVersion: true
	})),
	on(UserActions.oldVersion, (state) => ({
		...state,
		latestVersion: false
	})),
	on(UserActions.adminOn, (state) => ({
		...state,
		admin: true
	})),
	on(UserActions.adminOff, (state) => ({
		...state,
		admin: false
	})),
	on(UserActions.logout, (state) => ({
		...state,
		logout: true
	})),
	on(UserActions.tokenRefreshing, (state, {isRefreshing}) => ({
		...state,
		tokenRefreshing: isRefreshing
	})),
	on(UserActions.logoutAfterEntrySave, (state) => ({
		...state,
		logoutAfterEntrySave: true
	}))
);
